import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss']
})
export class StepThreeComponent implements OnInit {

  isLoading = false;
  checkAllDone = true;
  pageTitle: string;

  routeId = JSON.parse(localStorage.getItem('currentRouteId'));
  currentRoute = JSON.parse(localStorage.getItem('userRoutes')).find(id => id.id === this.routeId);
  currentRoutePoints: any;
  currentPointEdit: number = 0;

  placesService: google.maps.places.PlacesService;

  googleInfos: any = [];

  titles: any = [];
  descriptions: any = [];
  moreinfos: any = [];
  youtubes: any = [];

  files: any[] = [];

  constructor(private http: HttpClient, private apiService: ApiService, private router: Router, private ref: ChangeDetectorRef, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.pageTitle = 'Édition du circuit ' + this.currentRoute.title;
    this.getPoints();
  }

  getPoints() {
    this.apiService.getPoints('fr_FR', {route_id: this.routeId}).subscribe(
      data => {
        this.currentRoutePoints = JSON.parse(localStorage.getItem('currentRoutePoints'));
        this.checkIfAllDone();
        this.currentRoutePoints.forEach((element, index) => {
          this.files.push([]);
          this.googleInfos.push({});
          this.getPointsGoogleDetails(element, index);
          (element.title) ? this.titles.push(element.title) : this.titles.push("");
          (element.description) ? this.descriptions.push(element.description) : this.descriptions.push("");
          (element.moreinfo) ? this.moreinfos.push(element.moreinfo) : this.moreinfos.push("");
          (element.youtube) ? this.youtubes.push(element.youtube) : this.youtubes.push("");
          if (element.medias.length) this.populateMedias(element.medias, index);
        });
      },
      err => {
        console.log(err);
      }
    );
  }

  getPointsGoogleDetails(element, index) {
    const request = {
      placeId: element.googleplace_id
    };
    this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
    this.placesService.getDetails(request, (place, status) => {
      if (status === 'OK') {
        this.googleInfos[index].title = place.name;
        this.googleInfos[index].horaires = place.opening_hours.weekday_text.join('\n');
        this.googleInfos[index].description = place.formatted_address;
        if (place.photos) {
          var photos = place.photos;
          var urls = []; // we will store the urls here
          photos.slice(0, 6).forEach((photo) => {
            urls.push(photo.getUrl({
              maxWidth: 800,
              maxHeight: undefined
            }));
          });
          this.googleInfos[index].medias = urls;
          this.detectChanges();
        }
      }
    });
  }

  populateMedias(element, index) {
    element.forEach((element) => {
      let format = element.url.substring(element.url.lastIndexOf('.') + 1);
      let name = element.url.substring(element.url.lastIndexOf('/') + 1);
      let file = dataURLtoFile('data:image/' + format + ';base64,' + element.data, name);
      this.files[index].push(file);
    });
  }

  onCopyData(data, type, index) {
    if (type == 'title') this.titles[index] = data;
    if (type == 'description') this.descriptions[index] = data;
    if (type == 'moreinfo') this.moreinfos[index] = data;
  }

  onCopyImage(targetUrl, event) {
    const proxyUrl = "https://cors-anywhere.herokuapp.com/";
    this.http.get(proxyUrl + targetUrl, {responseType: 'blob'}).subscribe(data => {
      let extension = data.type.split('/')[1];
      let name = 'from-google-' + (+new Date).toString(36).slice(-5) + '.' + extension;
      let file = new File([data], name, {type: data.type, lastModified: +new Date});
      event.target.classList.add(name);
      this.files[this.currentPointEdit].push(file);
      this.detectChanges();
    })
  }

  onSelect(event) {
    this.files[this.currentPointEdit].push(...event.addedFiles);
  }

  onRemove(event) {
    this.files[this.currentPointEdit].splice(this.files[this.currentPointEdit].indexOf(event), 1);
    this.detectChanges();
  }

  detectChanges() {
    this.ref.detectChanges();
    setTimeout(() => {
      this.ref.detectChanges();
    }, 100);
  }

  savePointThenChange(toIndex, direct?) {
    this.isLoading = true;
    let statut_edit = '0';
    if (this.files[this.currentPointEdit].length && this.titles[this.currentPointEdit] && this.descriptions[this.currentPointEdit]) {
      statut_edit = '1';
    }
    this.apiService.addPoint(
      this.routeId,
      this.currentRoutePoints[this.currentPointEdit].lang,
      this.currentRoutePoints[this.currentPointEdit].lat,
      this.currentRoutePoints[this.currentPointEdit].lon,
      this.titles[this.currentPointEdit],
      {
        point_id: this.currentRoutePoints[this.currentPointEdit].id,
        googleplace_id: this.currentRoutePoints[this.currentPointEdit].googleplace_id,
        description: this.descriptions[this.currentPointEdit],
        moreinfo: this.moreinfos[this.currentPointEdit],
        youtube: this.youtubes[this.currentPointEdit],
        medias: this.files[this.currentPointEdit],
        statut_edit: statut_edit
      }).subscribe(
      data => {
        if (direct) {
          this.updatePoint(this.currentRoutePoints[this.currentPointEdit].id, toIndex, direct);
        } else {
          this.updatePoint(this.currentRoutePoints[this.currentPointEdit].id, toIndex);
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  updatePoint(id, toIndex, direct?) {
    this.apiService.getPoints('fr_FR', {route_id: this.routeId}).subscribe(
      data => {
        this.currentRoutePoints[this.currentPointEdit] = data.data.find(element => element.id === id);
        this.checkIfAllDone();
        if (direct) {
          this.directNavigation(direct);
        } else if (toIndex == 'next') {
          this.navigateNext();
        } else if (toIndex == 'prev') {
          this.navigatePrev();
        } else {
          this.changeCurrentPointEdit(toIndex);
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  navigatePrev() {
    if (this.currentPointEdit == 0) {
      this.router.navigate(['/create-circuit-2']);
    } else {
      this.currentPointEdit = this.currentPointEdit - 1;
      document.querySelector(".create-circuit").scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.isLoading = false;
    }
  }

  navigateNext() {
    if (this.checkIfAllDone()) {
      this.router.navigate(['/create-circuit-4']);
    }
    if (this.currentPointEdit == this.currentRoutePoints.length - 1) {
      if (this.checkIfAllDone()) {
        this.router.navigate(['/create-circuit-4']);
      } else {
        document.querySelector(".create-circuit").scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.isLoading = false;
        this.toastr.warning('Tous vos points doivent contenir au mois un titre, une description et une image.', '', {
          timeOut: 8000,
        });
      }
    } else {
      this.currentPointEdit = this.currentPointEdit + 1;
      document.querySelector(".create-circuit").scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.isLoading = false;
    }
  }

  directNavigation(destination) {
    if (destination > 3) {
      if (this.checkIfAllDone()) {
        this.router.navigate(['/create-circuit-' + destination]);
      } else {
        document.querySelector(".create-circuit").scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.isLoading = false;
        this.toastr.warning('Tous vos points doivent contenir au mois un titre, une description et une image', '', {
          timeOut: 8000,
        });
      }
    } else {
      this.router.navigate(['/create-circuit-' + destination]);
    }
  }

  changeCurrentPointEdit(index) {
    this.currentPointEdit = index;
    this.isLoading = false;
    this.detectChanges();
  }

  checkIfAllDone() {
    this.checkAllDone = true;
    this.currentRoutePoints.forEach((element, index) => {
      if (element.statut_edit == 0) {
        this.checkAllDone = false;
      }
    });
    return this.checkAllDone;
  }

}

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
  mime = arr[0].match(/:(.*?);/)[1],
  bstr = atob(arr[1]),
  n = bstr.length,
  u8arr = new Uint8Array(n);

  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, {type:mime});
}
